import { Search, ShieldCheck, Package, Truck, Globe, Rocket } from "lucide-react";
import { Card3D } from "@/components/3d/Card3D";

const services = [
  {
    icon: Search,
    title: "Product Sourcing",
    description: "Access India's vast network of verified manufacturers and suppliers across industries.",
  },
  {
    icon: ShieldCheck,
    title: "Supplier Verification",
    description: "Rigorous vetting process ensuring you partner only with reliable, quality-certified suppliers.",
  },
  {
    icon: Package,
    title: "Bulk Procurement",
    description: "Competitive pricing and efficient handling for large-volume orders with seamless coordination.",
  },
  {
    icon: Truck,
    title: "Export & Logistics",
    description: "End-to-end shipping solutions with customs clearance and documentation support.",
  },
  {
    icon: Globe,
    title: "B2B International Sales",
    description: "Connecting your business with pre-qualified global buyers ready for partnership.",
  },
  {
    icon: Rocket,
    title: "Future B2C Expansion",
    description: "Preparing infrastructure for direct-to-consumer channels as your business grows.",
  },
];

export function ServicesSection() {
  return (
    <section className="py-24 bg-card/50 relative overflow-hidden">
      {/* Subtle grid background */}
      <div 
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `
            linear-gradient(to right, hsl(43 70% 50%) 1px, transparent 1px),
            linear-gradient(to bottom, hsl(43 70% 50%) 1px, transparent 1px)
          `,
          backgroundSize: "60px 60px",
        }}
      />

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-4">
            India to World <span className="text-gradient-gold">Export Solutions</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive trade services designed to simplify your international sourcing and export operations.
          </p>
        </div>

        {/* Services Grid with 3D Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <Card3D key={service.title}>
              <div
                className="group h-full p-8 rounded-2xl bg-gradient-card border border-border hover:border-primary/50 transition-all duration-300"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-14 h-14 rounded-xl bg-secondary flex items-center justify-center mb-6 group-hover:bg-primary/10 transition-colors group-hover:shadow-[0_0_25px_hsl(43_70%_47%/0.25)]">
                  <service.icon className="w-7 h-7 text-primary" />
                </div>
                <h3 className="text-xl font-serif font-semibold text-foreground mb-3">
                  {service.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </div>
            </Card3D>
          ))}
        </div>
      </div>
    </section>
  );
}
